// import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
// import React, { memo, useContext } from 'react'
// import { AuthenticationContext } from '../../context/AuthenticationContext'
// import { WmcContext } from '../../context/WmcContext'
// import { WEB_KEY } from '../../api/AxiosApi'
// import Image from 'mui-image'

// function TopHeader() {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext)
//     const { BrandLogo } = useContext(WmcContext)
//     const { breakpoints, spacing } = useTheme()
//     const LOGIN_ID = localStorage.getItem('LoginID')
//     // const LOC_CODE = localStorage.getItem('LCODE')
//     const matches = useMediaQuery(breakpoints.down('xl'));
//     // console.log('DATAUSER', LoggedInUserInfo)
//     const LOC_CODE = LoggedInUserInfo?.Loc_Code
//     const PASS_KEY = "xxxxxx"
//     // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"
//     const ImageUrl = `https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
//     // console.log('LOGO', ImageUrl)
//     return (
//         <Stack rowGap={spacing(1)}>
//             <Card elevation={0} sx={{ bgcolor: 'primary.light' }}>
//                 <CardActions>
//                     <marquee>
//                         {/* <Typography variant='body1' color={'background.default'}>
//                             {LoggedInUserInfo?.username}      Plant Capacity : {LoggedInUserInfo?.PLANT_CAPACITY}     {LoggedInUserInfo?.MSG}      Logics PowerAMR is the leading global provider of Solar Monitoring Management Solutions. We deliver innovative and flexible solutions to help EPC solve their complex challenges in Solar Energy Management, Intelligence and Smart infrastructure.      CC- 011-42547646 ; info@poweramr.in ; www.PowerAMR.com

//                         </Typography> */}

//                         <Typography
//                             variant="body1"
//                             color="background.default"
//                             sx={{
//                                 display: "flex",
//                                 flexWrap: "wrap",
//                                 gap: "12px",   // 👉 yaha se gap control karo
//                             }}
//                         >
//                             <span>{LoggedInUserInfo?.username}</span>

//                             <span>
//                                 Plant Capacity : {LoggedInUserInfo?.PLANT_CAPACITY}
//                             </span>

//                             <span>{LoggedInUserInfo?.MSG}</span>

//                             <span>
//                                 Logics PowerAMR is the leading global provider of Solar Monitoring
//                                 Management Solutions.
//                             </span>

//                             <span>
//                                 CC- 011-42547646 ; info@poweramr.in ; www.PowerAMR.com
//                             </span>
//                         </Typography>
//                     </marquee>
//                 </CardActions>
//             </Card>
//             <Grid container spacing={spacing(1)}>
//                 <Grid item xs={12} sm={12} md={4}>
//                     <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
//                         <Stack>
//                             <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfo?.username}</Typography>
//                             <Typography textAlign={'start'} variant='body1'>Plant Capacity : {LoggedInUserInfo?.PLANT_CAPACITY}</Typography>
//                         </Stack>
//                     </Card>
//                 </Grid>
//                 <Grid item xs={12} sm={12} md={4}>
//                     <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
//                         <Stack>
//                             <Typography variant='body1'>{LoggedInUserInfo?.MSG}</Typography>
//                         </Stack>
//                     </Card>
//                 </Grid>
//                 <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
//                     <Image fit='fill'
//                         wrapperStyle={{ height: matches ? 50 : 70 }}
//                         src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
//                     />
//                 </Grid>
//             </Grid>
//         </Stack >
//     )
// }

// export default memo(TopHeader)


// 2.


import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../context/AuthenticationContext'
import { WmcContext } from '../../context/WmcContext'
import { WEB_KEY } from '../../api/AxiosApi'
import Image from 'mui-image'
import { BaseUrl } from '../../api/AxiosApi'
import { AppThemeContext } from '../../context/AppThemeContext'
import { logApi, MainSumApi } from '../../api/Api'
import { getDateTimeForDashboardTab1 } from '../../utils'
import { GiFruitTree } from "react-icons/gi";
import { MdCo2 } from "react-icons/md";
import { MdOutlineCo2 } from "react-icons/md";
import { GiCoalWagon } from "react-icons/gi";
import { GiReceiveMoney } from "react-icons/gi";

function TopHeader() {
    const [logData, setLogData] = useState([]);
    const { PrimaryColor } = useContext(AppThemeContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { BrandLogo } = useContext(WmcContext)
    const { breakpoints, spacing } = useTheme()
    const LOGIN_ID = localStorage.getItem('LoginID')
    //const LOC_CODE = localStorage.getItem('LCODE')
    const matches = useMediaQuery(breakpoints.down('xl'));
    // console.log('DATAUSER', LoggedInUserInfo)
    const LOC_CODE = LoggedInUserInfo?.Loc_Code
    const PASS_KEY = "xxxxxx"

    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)


    // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"



    // const ImageUrl = `https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`





    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    });


    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);

    // This fetching for total inverters


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });

    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };


    useEffect(() => {
        fetchData();
    }, [sumCredentials]);


    return (
        <Stack rowGap={spacing(1)}>
            


            <Grid container spacing={spacing(1)}>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfo?.username}&nbsp; &nbsp;<span>(User_Id:{LOGIN_ID})</span></Typography>
                            {/* <Typography textAlign={'start'} variant='body1'>Plant AC Capacity : {LoggedInUserInfo?.PLANT_CAPACITY} {LoggedInUserInfo?.AC_Unit} &nbsp; &nbsp; Plant DC Capacity : {LoggedInUserInfo?.DC_CAPACITY} {LoggedInUserInfo?.DC_Unit}</Typography> */}
                            <Typography textAlign={'start'} variant='body1'> {LoggedInUserInfo?.Address} &nbsp;, &nbsp;<span>({LoggedInUserInfo?.city})</span></Typography>
                        </Stack>
                                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography variant='body1'>{LoggedInUserInfo?.MSG}</Typography>
                            {/* <Typography variant='body1' sx={{ color: PrimaryColor }}>Plant Commissioned Date:{LoggedInUserInfo?.PLANT_COMMISSIONED_DATE}</Typography> */}
                            <Typography variant='body1' sx={{ color: PrimaryColor }}>Subscription Expiry Date:{LoggedInUserInfo?.subscription_expiry_date}</Typography>
                        </Stack>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
                    <Image fit='fill'
                        wrapperStyle={{
                            height: matches ? 50 : 70, borderRadius: "11px",
                            overflow: "hidden"
                        }}
                        src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
                    />
                </Grid>
                
            </Grid>
        </Stack >
    )
}

export default memo(TopHeader)